module.exports = __webpack_public_path__ + "static/7-c3d5a85716b806e912d8710fe18edd13.jpg";